import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load all export components
const ExportsLayout = lazy(() => import('../layouts/ExportsLayout').then(m => ({ default: m.ExportsLayout })));
const ExportsMainPage = lazy(() => import('../pages/ExportsMainPage').then(m => ({ default: m.ExportsMainPage })));
const SalesExportPage = lazy(() => import('../pages/SalesExportPage').then(m => ({ default: m.SalesExportPage })));
const TdsExportPage = lazy(() => import('../pages/TdsExportPage').then(m => ({ default: m.TdsExportPage })));
const TcsExportPage = lazy(() => import('../pages/TcsExportPage').then(m => ({ default: m.TcsExportPage })));

export const exportRoutes: RouteObject[] = [
  {
    path: '/export-data',
    element: <ExportsLayout />,
    children: [
      {
        index: true,
        element: <SalesExportPage />,
      },
    ],
  },
  {
    path: '/exports/*',
    element: <ExportsLayout />,
    children: [
      {
        index: true,
        element: <ExportsMainPage />,
      },
      {
        path: 'sales',
        element: <SalesExportPage />,
      },
      {
        path: 'tds',
        element: <TdsExportPage />,
      },
      {
        path: 'tcs',
        element: <TcsExportPage />,
      },
    ],
  },
];